var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticStyle:{"height":"100vh"},attrs:{"align":"center","justify":"center"}},[_c('div',{staticClass:"text-center"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":"64"}}),_c('div',{staticClass:"mt-4 grey--text"},[_vm._v("Completing sign in...")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }